import Fuse from 'fuse.js';
import csvData from 'bundle-text:./products-2.csv';
import { CSV } from './csv';

let params = (new URL(window.location.href)).searchParams;
export let currency = 'MXN';

console.log(csvData);
console.log(CSV.csvToObject(csvData));
export const productsList = CSV.csvToObject(csvData)
    // filter out products without SKU
    .filter((product: any) => {
        const sku = product['Supplier Part ID'];

        return sku != null && String(sku).trim() !== '';
    }).map((product: any) => {
    console.log(product);
    return {
        sku: product['Supplier Part ID'].toString(),
        image: '/assets/images/' + addjpgextension(product['Image-1']?.toString().replace(/\s+/g, '')),
        name: product['Item Description'].toString(),
        description: product['Item Description'].toString(),
        price: parseFloat(product['Unit Price']?.toString()),
        category: [
            product.Group,
        ].filter(it => it).join('/'),
        unit: (product['Unit of Measure'] || 'EA').toUpperCase(),
        unspsc: product['Classification Codes-1']?.toString(),
        currency: currency,
        data: product,
    }
}).filter(it => {
    it.price > 0
    return it.price > 0;
});

// console.log(productsList);

export function addjpgextension(img: string) {
    if (!img) return img;
    if (img.toLowerCase().endsWith('.jpg')) {
        return img;
    }
    return img + '.jpg';
}


export function currencySymbol(currency: string) {
    return { 'USD': '$', 'EUR': '€', 'MXN': 'MX$' }[currency] || currency;
}

export interface Product {
    category: string;
    image: string;
    brand: string;
    description: any;
    sku: string;
    name: string;
    price: number;
    currency: string;
    data: any,

}
export interface CartItem {
    id: string;
    product: Product,
    quantity: number,
    options: any,
};

export class Cart {

    items: CartItem[] = [];
}

export class Model {

    cartClass = '';
    search: string = '';
    filter: any = {};

    products: Product[] = productsList;


    cart = new Cart();



    constructor() {
        if (localStorage.getItem('cart')) {
            this.cart = JSON.parse(localStorage.getItem('cart') as any);
        }
    }




}


export type Action
    = { type: 'add', product: Product, quantity: number, options: any }
    | { type: 'remove', product: Product }
    | { type: 'quantity', id: string, quantity: number }
    | { type: 'products', products: Product[] }
    | { type: 'filter', filter: any }
    | { type: 'filter.in', key: string, option: string, value: boolean }
    | { type: 'search', value: string }
    | { type: 'filter.clear' }
    | { type: 'cart.clear' }
    | { type: 'endanimate' };


let fuse = new Fuse([]);

export function RootReducer(state: Model, action: Action) {
    console.log(action);
    switch (action.type) {
        case 'cart.clear':
            state.cart.items = [];
            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'filter.clear':
            state.search = '';
            state.filter = {};
            break;
        case 'search':
            state.search = action.value;
            break;
        case 'add':
            const id = hash([action.product.sku, action.options]);
            const item = state.cart.items.find(it => it.id == id);
            if (item) {
                item.quantity += action.quantity;
            } else {
                state.cart.items.push({ ...action, id });
            }
            state.cartClass = 'animate__animated animate__headShake';

            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'quantity':
            // update quantity
            state.cart.items.filter(it => it.id == action.id).forEach(it => it.quantity = action.quantity);
            // remove if quantity is 0
            state.cart.items = state.cart.items.filter(it => it.quantity);

            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'products':
            state.products = [...action.products];
            fuse = new Fuse(state.products, { keys: ['name', 'sku', 'description'], findAllMatches: true, threshold: 0.4 });
            break;
        case 'filter':
            state.filter = action.filter;
            break;
        case 'filter.in':
            state.filter[action.key] = state.filter[action.key] || [];
            if (action.value) {
                state.filter[action.key].push(action.option);
            } else {
                state.filter[action.key] = state.filter[action.key].filter(it => it !== action.option);
            }
            if (state.filter[action.key].length == 0) {
                delete state.filter[action.key];
            }
            break;
        case 'endanimate':
            state.cartClass = '';
            break;
        default:
            break;
    }
    return { ...state };
}




export function search(state: Model) {

    let products = state.products;

    if (state.search) {
        products = fuse.search(state.search).map(it => it.item);
    }

    return products.filter(product => {
        for (const key in state.filter) {
            const value = state.filter[key];
            if (value == undefined) {
                continue;
            } else if (Array.isArray(value)) {
                if (value.includes(product[key])) {
                    continue;
                }
            } else if (value == product[key]) {
                continue;
            }
            return false;
        }
        return true;
    });
}

const hash = (str: any) => {
    if (typeof (str) !== 'string') {
        str = JSON.stringify(str);
    }
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
};


